import { render, staticRenderFns } from "./AirportPraia.vue?vue&type=template&id=1a5a2b92&scoped=true&"
import script from "./AirportPraia.vue?vue&type=script&lang=js&"
export * from "./AirportPraia.vue?vue&type=script&lang=js&"
import style0 from "./AirportPraia.vue?vue&type=style&index=0&id=1a5a2b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5a2b92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VDialog,VFlex,VIcon,VLayout,VProgressLinear})
